module.exports = __webpack_public_path__ + "img/back-arrow.4905339f.svg";